import {applyMiddleware, createStore} from 'redux';
import widgetReducer from './WidgetReducer';
import logger from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';

const WidgetStore= createStore(widgetReducer);


export default WidgetStore;